import { render, staticRenderFns } from "./UnsuspendAccount.vue?vue&type=template&id=48990272"
import script from "./UnsuspendAccount.vue?vue&type=script&lang=js"
export * from "./UnsuspendAccount.vue?vue&type=script&lang=js"
import style0 from "./UnsuspendAccount.vue?vue&type=style&index=0&id=48990272&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48990272')) {
      api.createRecord('48990272', component.options)
    } else {
      api.reload('48990272', component.options)
    }
    module.hot.accept("./UnsuspendAccount.vue?vue&type=template&id=48990272", function () {
      api.rerender('48990272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmailAccounts/UnsuspendAccount.vue"
export default component.exports